import { styler } from 'react-timeseries-charts';
import {
  solarColorArray,
  windColorArray,
  windOffshoreColorArray,
  priceColor,
} from '../../styles/colors';
import { plotHeader } from '../../styles/plot';

export const styles = (theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
  container: {
    fontFamily: 'Flanders Art Sans!important',
    width: '100%',
    // height: '450px',
    paddingBottom: 12,
    // [theme.breakpoints.down('xs')]: {
    //   height: '320px',
    // },
    // [theme.breakpoints.up('sm')]: {
    //   height: '290px',
    // },
    // [theme.breakpoints.up('tablet')]: {
    //   height: '380px',
    // },
    // [theme.breakpoints.up('md')]: {
    //   height: '312px',
    // },
    // [theme.breakpoints.up('lg1660')]: {
    //   height: '270px',
    // },
    // [theme.breakpoints.up('xl')]: {
    //   height: '280px',
    // },
  },
  chartDiv: {
    width: '90%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  plotHeader,
  chart: {
    display: 'flex',
    alignItems: 'flex-end',
    margin: 0,
    [theme.breakpoints.up('xs')]: {
      width: '300px',
      maxHeight: '280px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '400px',
      height: '200px',
      maxHeight: '230px',
    },
    [theme.breakpoints.up('tablet')]: {
      width: '340px',
      height: '290px',
      maxHeight: '290px',
    },
    [theme.breakpoints.up('md')]: {
      width: '215px',
      height: 200,
      maxHeight: '230px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '280px',
    },
    [theme.breakpoints.up('lg1536')]: {
      width: '345px',
    },
    [theme.breakpoints.up('lg1660')]: {
      width: '360px',
      height: 200,
    },
    [theme.breakpoints.up('xl')]: {
      width: '370px',
      height: 210,
    },
  },
  indicatorTooltipContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginRight: '10px',
  },
  toolTipIconButton: {
    width: '24px',
    height: '24px',
    alignSelf: 'center!important',
  },
  toolTip: {
    textAlign: 'left',
    color: '#888!important',
    backgroundColor: '#aaaaaa',
    fontFamily: 'Flanders Art Sans!important',
    minHeight: '50px',
  },
  topLegend: {
    fontFamily: 'Flanders Art Sans!important',
    textAlign: 'left',
    width: '100%!important',
    marginLeft: '50px',
    fontWeight: 600,
  },
  bottomLegend: {
    fontFamily: 'Flanders Art Sans!important',
  },
  timeplotLegend: {
    justifyContent: 'center',
  },
  legendBox: {
    borderRadius: '5px',
    border: '1px solid #8b7f7e',
    padding: '5px',
    display: 'inline-block',
    fontSize: '10pt',
  },
  pricesDisclaimer: {
    fontSize: 10,
    margin: 0,
  },
});

export const plotConfigColor = {
  solar: '#fce0d4',
  wind: '#1eb0e6',
  windOffshore: '#1eb0e6',
};

export const plotStyle = {
  solar: {
    line: {
      normal: { stroke: '#e0b29b', fill: 'none', strokeWidth: 2 },
      highlighted: { stroke: '#c3714b', fill: 'none', strokeWidth: 3 },
    },
    area: {
      normal: { fill: solarColorArray[5], stroke: 'none', opacity: 0.5 },
      highlighted: {
        fill: solarColorArray[6],
        stroke: 'none',
        opacity: 0.8,
      },
    },
  },
  wind: {
    line: {
      normal: { stroke: '#9dbfcb', fill: 'none', strokeWidth: 2 },
      highlighted: { stroke: '#2f6273', fill: 'none', strokeWidth: 3 },
    },
    area: {
      normal: { fill: windColorArray[5], stroke: 'none', opacity: 0.5 },
      highlighted: {
        fill: windColorArray[6],
        stroke: 'none',
        opacity: 0.8,
      },
    },
  },
  windOffshore: {
    line: {
      normal: { stroke: '#aadadd', fill: 'none', strokeWidth: 2 },
      highlighted: { stroke: '#880000', fill: 'none', strokeWidth: 3 },
    },
    area: {
      normal: {
        fill: windOffshoreColorArray[5],
        stroke: 'none',
        opacity: 0.5,
      },
      highlighted: {
        fill: windOffshoreColorArray[6],
        stroke: 'none',
        opacity: 0.8,
      },
    },
  },
  solarForecast: {
    line: {
      normal: { stroke: '#a0826b', fill: 'none', strokeWidth: 1 },
      highlighted: { stroke: '#f9e9e3', fill: 'none', strokeWidth: 2 },
    },
    area: {
      normal: { fill: solarColorArray[0], stroke: 'none', opacity: 0.5 },
      highlighted: {
        fill: solarColorArray[1],
        stroke: 'none',
        opacity: 0.8,
      },
    },
  },
  windForecast: {
    line: {
      normal: { stroke: '#9dbfcb', fill: 'none', strokeWidth: 1 },
      highlighted: { stroke: '#82cbe5', fill: 'none', strokeWidth: 2 },
    },
    area: {
      normal: { fill: windColorArray[0], stroke: 'none', opacity: 0.5 },
      highlighted: {
        fill: windColorArray[1],
        stroke: 'none',
        opacity: 0.8,
      },
    },
  },
  windOffshoreForecast: {
    line: {
      normal: { stroke: '#aadadd', fill: 'none', strokeWidth: 1 },
      highlighted: { stroke: '#dd0000', fill: 'none', strokeWidth: 2 },
    },
    area: {
      normal: {
        fill: windOffshoreColorArray[10],
        stroke: 'none',
        opacity: 0.5,
      },
      highlighted: {
        fill: windOffshoreColorArray[1],
        stroke: 'none',
        opacity: 0.8,
      },
    },
  },
};

export const legendLabelStyle = {
  fontSize: 'normal',
  color: '#ffffff!important',
  solar: { fontSize: 'normal', color: '#ffffff' },
  wind: { fontSize: 'normal', color: '#ffffff' },
  windOffshore: { fontSize: 'normal', color: '#ffffff' },
  normal: { fontSize: 'normal', color: '#ffffff' },
  highlighted: { fontSize: '1.2em', color: '#ffffff' },
  selected: { fontSize: '1.2em', color: '#ffffff' },
  muted: { fontSize: '1.2em', color: '#ffffff' },
};

export const legendStyle = styler([
  {
    key: 'solar',
    color: solarColorArray[5],
    labelStyle: { color: '#ffffff' },
    paddingLeft: '20px',
  },
  {
    key: 'wind',
    color: windColorArray[5],
    labelStyle: { fontSize: 'normal', color: '#ffffff' },
  },
  {
    key: 'windOffshore',
    color: windOffshoreColorArray[5],
    labelStyle: { fontSize: 'normal', color: '#ffffff' },
  },
  {
    key: 'solarForecast',
    color: solarColorArray[0],
    labelStyle: {
      normal: { fontSize: 'normal', color: '#ffffff' },
      highlighted: { fontSize: '1.2em', color: '#ffffff' },
    },
  },
  {
    key: 'windForecast',
    color: windColorArray[0],
    labelStyle: legendLabelStyle,
  },
  {
    key: 'windOffshoreForecast',
    color: windOffshoreColorArray[10],
    labelStyle: legendLabelStyle,
  },
]);

export function getChartRowHeight(windowWidth) {
  if (windowWidth < 1660) {
    return 160;
  }
  // if (windowWidth < 1536) {
  // return 150;
  // }
  // if (windowWidth < 1440) {
  //   return 150;
  // }
  // if (windowWidth < 1366) {
  //   return 150;
  // }

  if (windowWidth < 1280) {
    return 150;
  }
  if (windowWidth < 960) {
    return 140;
  }
  if (windowWidth < 768) {
    return 250;
  }
  if (windowWidth < 600) {
    return 190;
  }
  return 175;
}

export const trackerStyle = {
  line: {
    stroke: '#777',
    strokeWidth: '5px',
    cursor: 'crosshair',
    pointerEvents: 'none',
  },
};

export const timeAxisStyle = {
  label: {},
  values: {
    'font-size': 11,
    'font-family': 'Flanders Art Sans',
    color: '#8b7f7e',
    fill: '#8b7f7e',
  },
  ticks: {},
  axis: {},
};

export const yAxisStyle = {
  label: {
    fontWeight: 400,
    'font-size': 11,
    'font-family': 'Flanders Art Sans',
  },
  values: {
    'font-size': 11,
    'font-family': 'Flanders Art Sans',
    color: '#8b7f7e',
    fill: '#8b7f7e',
  },
};

export const yAxisPriceStyle = {
  values: {
    ...yAxisStyle.values,
    fill: priceColor,
  },
  label: {
    ...yAxisStyle.label,
    fill: priceColor,
  },
  tick: {
    stroke: priceColor,
  },
  axis: {
    stroke: priceColor,
  },
};
